module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-38.8d19ced1.png";